module.exports = __webpack_public_path__ + "img/fanny.f424cf47.webp";